<template>
<div class="subMasterCopySettingForm">
  <el-form
  >
    <el-form-item>
      <p class="self-label">{{$t('withgold.accountNumber')}}</p>
      <el-input
        disabled
        :value="login"></el-input>
    </el-form-item>
    <el-form-item>
      <p class="self-label">{{$t('nickname')}}</p>
      <el-input
        disabled
        :value="alias"></el-input>
    </el-form-item>
    <el-form-item>
      <p class="self-label">
        <account-role-tips></account-role-tips>
      </p>
      <el-input disabled :value="$t('MAM_Investment_Account')"></el-input>
    </el-form-item>
  </el-form>
  <mam-sub-follow-setting
    ref="editform"
    :form-data="formData"
    @send-form="sendFormHandle"
  >
  </mam-sub-follow-setting>
</div>
</template>

<script>
import accountRoleTips from '@/components/public/accountRoleTips'
import { queryLoginConfig, updateLoginConfig } from '@/api/config'
import mamSubFollowSetting from '@/components/common/mamSubFollowSetting'
export default {
  name: "subMasterCopySettingForm",
  components:{
    mamSubFollowSetting,
    accountRoleTips
  },
  props: {
    accountMtId: {
      type: Number,
      default: 0
    },
    dialogShow:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      formData:{
        stopRatio: ''
      },
      alias: '',
      login: '',
    };
  },
  watch: {
    dialogShow(val){
      if(val && this.accountMtId){
        this.queryConfig();
      }
    }
  },
  methods: {
    queryConfig(){
      queryLoginConfig({
        mtId: this.accountMtId,
      }).then((res) => {
        this.login = res.data.login;
        this.alias = res.data.alias;
        this.formData.stopRatio = res.data.stopLoss || '';
      })
    },
    saveHandle(){
      this.$refs.editform.validate();
    },
    sendFormHandle(form){
      // ajax
      updateLoginConfig({
        mtId: this.accountMtId,
        stopLoss: form.stopRatio,
      }).then((res) => {
        this.$emit('save-success');
        this.$message({
          type: 'success',
          message: this.$t('Saved_successfully')
        })
      })
    },
  }
}
</script>

<style scoped>

</style>
